import React from 'react'
import { PARTICIPANT_COLORS, hashString, MYAGENT_COLOR } from './participantColors.js'
import { ChatIcon, TrashIcon } from './icons.jsx'
import './ConversationSidebar.css'

/**
 * ConversationSidebar — conversation list rendered in the sidebar Chats tab
 */
export const ConversationSidebar = ({
  conversations = [],
  activeConversationId,
  onSelect,
  onDelete,
  onCreate,
  onClear,
  contacts = [],
}) => {
  const chatContacts = contacts.filter(p => p.roleType === 'chat' && p.online)

  return (
    <div className="conv-list">
      {/* Main Chat — always first */}
      <div className={`conv-item${activeConversationId === null ? ' conv-item-active' : ''}`}>
        <button className="conv-item-btn" onClick={() => onSelect(null)}>
          <div className="conv-item-icon" style={{ background: `linear-gradient(135deg, ${MYAGENT_COLOR}22, ${MYAGENT_COLOR}11)` }}>
            <ChatIcon color={MYAGENT_COLOR} />
          </div>
          <div className="conv-item-info">
            <div className="conv-item-name">Main Chat</div>
            <div className="conv-item-hint">MyAgent + all bots</div>
          </div>
        </button>
        {onClear && (
          <button
            className="conv-item-delete"
            onClick={(e) => { e.stopPropagation(); onSelect(null); onClear() }}
            title="Clear main chat"
          >
            <TrashIcon />
          </button>
        )}
      </div>

      {/* Direct conversations */}
      {conversations.map(conv => {
        const color = PARTICIPANT_COLORS[hashString(conv.targetRoleId) % PARTICIPANT_COLORS.length]
        const isActive = activeConversationId === conv.id
        return (
          <div key={conv.id} className={`conv-item${isActive ? ' conv-item-active' : ''}`}>
            <button className="conv-item-btn" onClick={() => onSelect(conv.id)}>
              <div className="conv-item-icon" style={{ background: `linear-gradient(135deg, ${color}22, ${color}11)` }}>
                <ChatIcon color={color} />
              </div>
              <div className="conv-item-info">
                <div className="conv-item-name">{conv.title || 'New conversation'}</div>
              </div>
            </button>
            <button
              className="conv-item-delete"
              onClick={(e) => { e.stopPropagation(); onDelete(conv.id) }}
              title="Delete conversation"
            >
              <TrashIcon />
            </button>
          </div>
        )
      })}

      {/* New conversation buttons */}
      {chatContacts.length > 0 && (
        <div className="conv-new-section">
          <div className="conv-new-label">New chat with:</div>
          {chatContacts.map(p => {
            const color = PARTICIPANT_COLORS[hashString(p.roleId) % PARTICIPANT_COLORS.length]
            return (
              <button key={p.roleId} className="conv-new-btn" onClick={() => onCreate(p)}>
                <span className="conv-new-dot" style={{ background: color }} />
                {p.displayName}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
